import { NgModule } from '@angular/core';
import { PipelineCardComponent } from './pipeline-card.component';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AsyncUiModule, VaIconModule } from '@vendasta/uikit';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { PreferredCurrencyModule } from '@vendasta/sales-common';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { Observable } from 'rxjs';
import {
  ALL_SALESPEOPLE,
  DEFAULT_CURRENCY,
  OPPORTUNITY_INFO_URL_BUILDER,
  OpportunityInfoUrlBuilder,
  PIPELINE_CARD_CONFIG_TOKEN,
  PipelineCardConfig,
  DETAILS_CONFIG_TOKEN,
} from './tokens';
import { Salesperson } from '@galaxy/types';
import { MeddicModule } from '../../meddic/meddic.module';
import { DetailsConfig } from '../../sales-opportunities/opportunity';
import { OpportunityServiceModule } from '../../sales-opportunities/opportunity-service.module';

@NgModule({
  declarations: [PipelineCardComponent],
  exports: [PipelineCardComponent],
  imports: [
    MatCardModule,
    CommonModule,
    AsyncUiModule,
    TranslateModule,
    RouterModule,
    PreferredCurrencyModule,
    MatIconModule,
    MatCheckboxModule,
    FormsModule,
    VaIconModule,
    MatTooltipModule,
    MeddicModule,
    DragDropModule,
    OpportunityServiceModule,
  ],
  providers: [
    { provide: ALL_SALESPEOPLE, deps: [PIPELINE_CARD_CONFIG_TOKEN], useFactory: allSalesPeopleFactory },
    { provide: DEFAULT_CURRENCY, deps: [PIPELINE_CARD_CONFIG_TOKEN], useFactory: defaultCurrencyFactory },
    {
      provide: OPPORTUNITY_INFO_URL_BUILDER,
      deps: [PIPELINE_CARD_CONFIG_TOKEN],
      useFactory: opportunityUrlBuilderFactory,
    },
    {
      provide: DETAILS_CONFIG_TOKEN,
      deps: [PIPELINE_CARD_CONFIG_TOKEN],
      useFactory: detailsConfigFactory,
    },
  ],
})
export class PipelineCardModule {}
function allSalesPeopleFactory(config: PipelineCardConfig): Observable<Salesperson[]> {
  return config.allSalespeople$;
}

function defaultCurrencyFactory(config: PipelineCardConfig): Observable<string> {
  return config.defaultCurrency$;
}

function opportunityUrlBuilderFactory(config: PipelineCardConfig): OpportunityInfoUrlBuilder {
  return config.opportunityInfoUrlBuilder;
}

function detailsConfigFactory(config: PipelineCardConfig): DetailsConfig {
  return config.detailsConfig;
}
